import { render, staticRenderFns } from "./MiniCartItem.vue?vue&type=template&id=18013a7c&"
import script from "./MiniCartItem.vue?vue&type=script&lang=js&"
export * from "./MiniCartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports